module.exports = __webpack_public_path__ + "c91f078fbaa9794ff6683434a623d7f4.svg";